import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { I18n } from "react-i18next";
import "../utils/i18n";
import "./Detail.css";
import LoadingSpinner from "../utils/LoadingSpinner";
import ErrorMessage from "../utils/ErrorMessage";
import Menu from "../app-header/Menu";
import Rx from "rxjs";
import api from "../api/api";
import DetailStandort from "./DetailStandort";
import DetailAllDispositionen from "./DetailAllDispositionen";
import DetailData from "./DetailData";
import DetailMedien from "./DetailMedien";

const initialState = {
  loading: true,
  allDispositionen: [],
  detail: {
    standort: {},
    orgelbauer: {},
    orgel: {
      spielhilfen: []
    },
    disposition: {
      dispositionen: []
    }
  },
  bibliographie: [],
  orgelgeschichte: [],
  medien: {
    images: [],
    medium: []
  }
};

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  fetchData(id) {
    if (this.subscription$ !== undefined) {
      this.subscription$ = this.subscription$.unsubscribe();
    }

    // all necessary streams have no "startWith"
    const allDisp$ = api.fetchAllDispositionen(id);
    const detail$ = api.fetchDetails(id).startWith(initialState.detail);
    const orgGesch$ = api
      .fetchOrgelgeschichte(id)
      .startWith(initialState.orgelgeschichte);
    const biblio$ = api
      .fetchBibliographie(id)
      .startWith(initialState.bibliographie);
    const medien$ = api.fetchMedien(id).startWith(initialState.medien);

    this.subscription$ = Rx.Observable.combineLatest([
      allDisp$,
      detail$,
      orgGesch$,
      biblio$,
      medien$
    ])
      .catch(err => this.setState({ error: err }))
      .subscribe(data => {
        const [
          allDispositionen,
          detail,
          orgelgeschichte,
          bibliographie,
          medien
        ] = data;

        this.setState(
          Object.assign(
            {
              error: undefined,
              loading: false,
              detail
            },
            allDispositionen,
            orgelgeschichte,
            bibliographie,
            medien
          )
        );
      });
  }

  reloadData(id) {
    this.setState(initialState);
    this.setState({
      allDispositionen: this.state.allDispositionen
    });
    this.fetchData(id);
  }

  componentWillReceiveProps(newProps) {
    this.reloadData(newProps.match.params.id);
  }

  componentDidMount() {
    this.reloadData(this.props.match.params.id);
  }

  componentWillUnmount() {
    if (this.subscription$ !== undefined) {
      this.subscription$ = this.subscription$.unsubscribe();
    }
  }

  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <Menu />
            {this.state.error !== undefined && (
              <div className="row">
                <div className="offset3 span6 error-container">
                  <ErrorMessage error={this.state.error} />
                </div>
              </div>
            )}
            <div className="row">
              <div className="offset4 span8">
                <DetailAllDispositionen
                  allDispositionen={this.state.allDispositionen}
                />
              </div>
            </div>
            <LoadingSpinner loading={this.state.loading}>
              <div className="row">
                <div className="span4">
                  <DetailMedien medien={this.state.medien} />
                </div>
                <div className="span8">
                  <DetailStandort standort={this.state.detail.standort} />
                  <DetailData
                    detail={this.state.detail}
                    bibliographie={this.state.bibliographie}
                    orgelgeschichte={this.state.orgelgeschichte}
                  />
                </div>
              </div>
            </LoadingSpinner>
          </div>
        )}
      </I18n>
    );
  }
}

export default withRouter(Detail);



// WEBPACK FOOTER //
// ./src/detail/Detail.js